//Angular
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

import { CacheService } from '../core/cache.service';
import { ApiService } from '../core/api.service';
import { Mappings } from '../../shared/mapping';
import { LanguageService } from '../cms/language.service';

@Injectable()
export class TemplateService {

  constructor(public _api: ApiService, public _cache: CacheService,
    private mappings: Mappings,
    private language: LanguageService,
    private cache: CacheService) {
  }


  getThankYouPagePaypalInfo(componentType, id) {
    let currentLang = this.language.getLongLang();
    let url = this.mappings.Web_Api_Get_Information_ThankYouPage_Paypal_Url
      .replace('{type}', componentType)
      .replace('{orderid}', id)
      .replace('{lang}', currentLang);
    return this._api.get(url);
  }

  getThankYouPagOnlineInfo(componentType, id) {
    let currentLang = this.language.getLongLang();
    let url = this.mappings.Web_Api_Get_Information_ThankYouPage_PagOnline_Url
      .replace('{type}', componentType)
      .replace('{orderid}', id)
      .replace('{lang}', currentLang);
    return this._api.get(url);
  }
  /**
   * return the html template for a given component
  */
  getComponentTemplate(componentType) {
    let currentLang = this.language.getLongLang();
    let url = this.mappings.Web_Api_Get_Template_Url
      .replace('{type}', componentType)
      .replace('{lang}', currentLang);
    return this._api.get(url);
  }
  
  getComponentTemplatePageNotFound(componentType) {
    let currentLang = this.language.getLongLang();
    let url = this.mappings.Web_Api_Get_Template_Url_Page_Not_Found 
      .replace('{type}', componentType)
      .replace('{lang}', currentLang);
    return this._api.get(url);
  }
  getHeadFootData() {
    let currentLang = this.language.getLongLang();

    let url = this.mappings.Web_Api_Get_Head_Foot_Data.replace('{lang}', currentLang);

    return this._api.get(url).do(json => {
      this.cache.clear(url);
    });
  }

}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/settings/template.service.ts